export enum SeverityType {
  Trace = 0,
  Information = 1,
  Warning = 2,
  Error = 3,
  Critical = 4
}